import store from "@/store";
import { getModule } from "vuex-module-decorators";
import ChatModule from "@/store/modules/Chat";
import Vue from 'vue';

const chatModule = getModule(ChatModule, store);

const notification = new Audio('/sound/notification.ogg');

store.subscribeAction((action) => {
    if (
        action.type === 'receiveMessage' &&
        (
            document.visibilityState === 'hidden' ||
            (
                !chatModule.currentChat ||
                action.payload.sessionId !== chatModule.currentChat.sessionId
            )
        )
    ) {
        notification.play();
    }
});
